module.exports = __webpack_public_path__ + "img/pvrnet.42ec1ebd.png";